// @flow
import React from 'react';
import useReactions from './hooks/useReactions';

type Props = {
    id: number,
    count: number
};

export default function ReactionCount({ id, count }: Props) {
    const { getReactionForId } = useReactions();
    const reactionData = getReactionForId(id);

    if (!reactionData) {
        return null;
    }

    let image = null;

    if (reactionData.imageURL) {
        image = (
            <img
                src={reactionData.imageURL}
                alt="reaction"
                className="reaction-image"
            />
        );
    } else {
        image = <span className="reaction-emoji">{reactionData.emoji}</span>;
    }
    return (
        <div className="reaction">
            {image}
            <span className="count">{count}</span>
        </div>
    );
}
